import { z } from 'zod';
/**
 * Lot 14 — données de marché (DVF). Contrat de `GET /market/communes` et de
 * `GET /market/communes/:code/dvf`.
 */
export const DVF_PROPERTY_TYPES = ['Appartement', 'Maison'];
/** Code INSEE de commune : cinq caractères (`97411`, `2A004`). */
export const inseeCodeSchema = z.string().regex(/^(\d{5}|2[AB]\d{3})$/, 'Code INSEE invalide');
export const communeSearchQuerySchema = z.object({
    q: z.string().trim().min(2, 'Au moins deux caractères').max(80),
});
export const communeSchema = z.object({
    code: inseeCodeSchema,
    name: z.string(),
    department: z.string(),
    postalCodes: z.array(z.string()),
    population: z.number().int().nonnegative().nullable(),
});
export const dvfQuerySchema = z.object({
    propertyType: z.enum(DVF_PROPERTY_TYPES).default('Appartement'),
    /** Retélécharge les fichiers DVF au lieu de relire les agrégats en cache. */
    refresh: z
        .enum(['true', 'false'])
        .default('false')
        .transform((value) => value === 'true'),
});
export const dvfYearSchema = z.object({
    year: z.number().int(),
    salesCount: z.number().int().nonnegative(),
    /** €/m² bâti, arrondi à l'euro ; `null` sans vente retenue. */
    medianPricePerM2: z.number().int().nullable(),
    p25PricePerM2: z.number().int().nullable(),
    p75PricePerM2: z.number().int().nullable(),
    medianSurfaceM2: z.number().int().nullable(),
    /** Assez de ventes pour qu'une médiane annuelle porte un calibrage. */
    reliable: z.boolean(),
});
export const dvfResponseSchema = z.object({
    inseeCode: inseeCodeSchema,
    communeName: z.string(),
    propertyType: z.enum(DVF_PROPERTY_TYPES),
    years: z.array(dvfYearSchema),
    /** Années dont le fichier n'existe pas (encore) chez l'Etalab. */
    missingYears: z.array(z.number().int()),
    calibration: z.object({
        /** Croissance annuelle nominale estimée ; `null` si l'historique est insuffisant. */
        annualGrowth: z.number().nullable(),
        endpointGrowth: z.number().nullable(),
        yearsUsed: z.array(z.number().int()),
        warnings: z.array(z.string()),
    }),
    fetchedAt: z.iso.datetime({ offset: true }),
    /** `true` quand les agrégats viennent du cache (aucun téléchargement). */
    fromCache: z.boolean(),
});
//# sourceMappingURL=market.js.map